import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Spinner } from "reactstrap";
const MySwal = withReactContent(Swal);

const MySwalBlockUi = () => {
  return MySwal.fire({
    title: <Spinner color="primary" />,
    text: "Loading ...",
    showCancelButton: false,
    showConfirmButton: false,
    allowOutsideClick: false,
    buttonsStyling: true,
  });
};

export default MySwalBlockUi;
